import { AfterViewInit, ChangeDetectionStrategy, Component, inject, input, linkedSignal, signal } from '@angular/core';
import { TableModule } from "primeng/table";
import { environment } from '../../../../../environments/environment';
import { AppAutofocusDirective } from '../../../../shared/directives/appAutofocus.directive';
import { triggerResource } from '../../../../shared/helpers/signal-helpers';
import { AuthService } from '../../../../shared/services/auth.service';
import { sharedImports } from '../../../../shared/shared';
import { GuiasService } from '../../../operations/services/guias.service';

@Component({
  selector: 'app-tracking',
  imports: [...sharedImports, AppAutofocusDirective, TableModule],
  templateUrl: './tracking.html',
  styleUrl: './tracking.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Tracking implements AfterViewInit {
  ngAfterViewInit(): void {
    this.search();
  }
  readonly guiaService = inject(GuiasService);
  readonly auth = inject(AuthService);
  readonly logoUrl = signal<string>(`${environment.apiUrl}/api/tenants/current/logo/${window.location.host.split('.')[0]}`);

  readonly trackingNumber = input<number | undefined>(undefined);
  readonly tracking = linkedSignal(() => this.trackingNumber());
  readonly guia = triggerResource(this.guiaService.resources.getTrackingInformation, this.tracking);

  search() {
    this.guia.trigger.set(this.tracking());
    this.guia.resource.reload();
  }

  goBack() {
    window.history.back();
  }

  googleMapsUrl(latitude: number | null | undefined, longitude: number | null | undefined): string | null {
    if (latitude == null || longitude == null) {
      return null;
    }

    return `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
  }
}
